export default __webpack_public_path__ + "static/media/7.aa1b777e.jpg";